// Shared HTML-escaping helper for strings that get injected into hand-built
// HTML rendered via v-html or written into print/PDF windows. Prevents stored
// XSS from user-controlled data (competitor/club names, descriptions, etc.).
export default function escapeHtml (text) {
  if (text === null || text === undefined) return ''
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}
